import { IconWrapper } from '../runtime';
export default IconWrapper('unknown-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'b25e1e23' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.4221 6.23438C10.3762 6.23438 9.54547 7.78704 9.46899 8.29688C9.44177 8.40578 9.41849 8.54236 9.39918 8.68135C9.34506 9.07069 9.02409 9.37687 8.63102 9.37928L7.90372 9.38375C7.46123 9.38646 7.11123 9.00719 7.16943 8.56853C7.20124 8.32873 7.23892 8.09132 7.2783 7.94249C7.48308 6.57733 9.03055 3.98438 12.4221 3.98438C14.1555 3.98438 15.4858 4.78229 16.2322 5.98793C16.9559 7.15698 17.0806 8.62675 16.625 9.93304C16.3683 10.6687 15.9191 11.2089 15.4678 11.6282C15.1462 11.927 14.7681 12.2098 14.4534 12.4453C14.3551 12.5189 14.2629 12.5879 14.1806 12.6512C13.4177 13.2385 13.0784 13.6369 13.0784 14.3438V14.7188C13.0784 15.133 12.7426 15.4688 12.3284 15.4688H11.5784C11.1641 15.4688 10.8284 15.133 10.8284 14.7188V14.3438C10.8284 12.5194 11.9421 11.535 12.8081 10.8683C12.9452 10.7628 13.0712 10.6685 13.1888 10.5804C13.4736 10.3672 13.7096 10.1904 13.9364 9.97974C14.2278 9.70904 14.4056 9.46408 14.5005 9.19196C14.7479 8.48263 14.6618 7.72584 14.3191 7.17223C13.999 6.65521 13.4075 6.23438 12.4221 6.23438Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M13.4942 18.4688C13.4942 19.2972 12.8659 19.9688 12.091 19.9688C11.316 19.9688 10.6877 19.2972 10.6877 18.4688C10.6877 17.6403 11.316 16.9688 12.091 16.9688C12.8659 16.9688 13.4942 17.6403 13.4942 18.4688Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'b25e1e23',
      "x1": "0",
      "y1": "0",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});